<template>
  <div class="popup-full  _new-design  modal-after-respond-without-resume">
    <div class="popup-full__wrap">

      <button type="button"
              @click.prevent="onClose"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__main">
            <div class="popup-full__media">
              <picture class="popup-full__img">
                <img src="../assets/img/popup/after-respond-without-resume.svg"
                     :alt="$tVacancy('Congratulations!')">
              </picture>
            </div>

            <h3 class="popup-full__title">{{ $tVacancy('Congratulations!') }}</h3>
            <div class="popup-full__text text">
              <p>{{
                  $tVacancy('modal_after_respond_without_resume_description')
                }}</p>
            </div>

            <div class="modal-after-respond-without-resume__soc-bot-wrap">
              <div class="modal-after-respond-without-resume__soc-bot-list flex-column items-center">
                <template v-for="messenger in messengers">
                  <a
                    :key="messenger"
                    :href="urlsComputed[messenger]"
                    target="_blank"
                    @click="onRespond(messenger)"
                    :class="'_' + messenger"
                    class="base-btn modal-after-respond-without-resume__link-button _viber"
                  >
                    <BaseSvg :name="`ico-${messenger}`" width="1.8rem" height="2rem" />
                    <span class="ml-1">{{ $tVacancy('go_to_chatbot') }}</span>
                  </a>
                </template>

                <div class="mt-2 mb-2">{{ $tGlobal('or') }}</div>

                <div
                  class="base-btn base-btn--green modal-after-respond-without-resume__link-button"
                  @click="onClose"
                >
                  {{ $tVacancy('fill_out_form_on_website') }}
                </div>
              </div>
            </div>

            <BasePreloader v-if="pending"/>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import respondOnAllBookedResumeChatBot from '@/actions/respondOnAllBookedResumeChatBot'
  import respondOnVacancyResumeChatBot from '@/actions/respondOnVacancyResumeChatBot'
  import startChatBot from '@/actions/startChatBot'
  import startChatBotPrimary from '@/actions/startChatBotPrimary'

  export default {
    name: 'ModalAfterRespondWithoutResume',
    props: {
      vacancyId: Number,
      many: Boolean,
      simple: Boolean,
      primary: Boolean,
      urls: {
        type: Object
      },
    },
    data() {
      return {
        pending: false,
        messengers: [
          'viber',
        ]
      }
    },
    computed: {
      urlsComputed() {
        return this.primary
          ? this.$store.state.user.chatBotUrlsPrimary
          : this.simple
            ? this.$store.state.user.chatBotUrls
            : (this.urls || this.$store.state.user.chatBotUrls)
      }
    },
    methods: {
      onClose() {
        this.$vModal.close('after-respond-without-resume')
      },
      onRespond(messenger) {
        if(!this.vacancyId) return

        this.pending = true

        const method = this.primary
          ? startChatBotPrimary
          : this.simple
            ? startChatBot
            : this.many
              ? respondOnAllBookedResumeChatBot
              : respondOnVacancyResumeChatBot

        method({vacancyId: this.vacancyId, messenger}).then(() => {
          this.onClose()
        }).finally(() => {
          this.pending = false
        })
      }
    }
  }
</script>

<style lang="less">

</style>
